import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../redux/actions/state';
import { Link, useNavigate } from 'react-router-dom';
import { Squeeze as Hamburger } from 'hamburger-react';

import './style.css';
import Flag from '../../Flag';
import { UpdateAppData } from '../SidebarMenu';
import { hasCapability } from '../../../utils/capabilities';

const MobileNav = ({ active }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const selectedLocale = useSelector((state) =>
    state.app.locales.find((locale) => locale.language === state.app.selectedLanguage)
  );

  const logoutNow = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div className="mb-12">
      <div className="fixed z-50 w-full h-12 top-0 left-0 right-0 bg-orange">
        <div className="flex flex-row justify-between items-center mx-12">
          <p className="flex items-center gap-2">
            <Flag countryCode={selectedLocale?.countryCode} style={{ width: 20, height: 13 }} />
            Menu
          </p>
          <Hamburger toggled={openMenu} toggle={() => setOpenMenu(!openMenu)} />
        </div>
      </div>
      {openMenu && (
        <div className="bg-orange fixed top-0 left-0 right-0 mt-12 z-50 p-4">
          <MenuItem
            title="Content"
            active={
              active === 'home' ||
              active === 'deals' ||
              active === 'tools' ||
              active === 'todo' ||
              active === 'knowledge' ||
              active === 'notification' ||
              active === 'notification-center' ||
              active === 'popup' ||
              active === 'premium-settings' ||
              active === 'settings'
            }
            heading
            content
          />
          <div className="ml-8 my-1px">
            <MenuItem to="/home" title="Home" active={active === 'home'} content />
            <MenuItem to="/deals" title="Deals" active={active === 'deals'} content />
            <MenuItem to="/tools" title="Tools" active={active === 'tools'} content />
            <MenuItem to="/todo" title="Todo" active={active === 'todo'} content />
            <MenuItem to="/knowledge" title="Knowledge" active={active === 'knowledge'} content />
            <MenuItem
              to="/notification"
              title="Push notifications"
              active={active === 'notification'}
              content
            />
            <MenuItem
              to="/notification-center"
              title="Notification center"
              active={active === 'notification-center'}
              content
            />
            <MenuItem to="/popup" title="Popup" active={active === 'popup'} content />
            <MenuItem
              to="/premium-settings"
              title="Premium settings"
              active={active === 'premium-settings'}
              content
            />
            <MenuItem to="/settings" title="Settings" active={active === 'settings'} content />
          </div>
          <MenuItem
            title="Analytics"
            active={
              active === 'useranalytics' ||
              active === 'contentanalytics' ||
              active === 'companyanalytics'
            }
            heading
            analytics
          />
          <div className="ml-8 my-1px">
            <MenuItem
              to="/useranalytics"
              title="Users"
              active={active === 'useranalytics'}
              analytics
            />
            <MenuItem
              to="/active-subscriptions"
              title="Active subscriptions"
              active={active === 'active-subscriptions'}
              analytics
            />
            <MenuItem
              to="/contentanalytics"
              title="App content"
              active={active === 'contentanalytics'}
              analytics
            />
            <MenuItem
              to="/companyanalytics"
              title="Company"
              active={active === 'companyanalytics'}
              analytics
            />
          </div>
          <MenuItem to="/forms" title="Forms" active={active === 'forms'} content />
          <MenuItem
            to="/translations"
            title="Translations"
            active={active === 'translations'}
            translation
          />
          <MenuItem to="/help" title="Help" active={active === 'help'} content />
          <MenuItem to="/appversion" title="AppVersion" active={active === 'appversion'} content />
          <MenuItem to="/userdelete" title="Delete user" active={active === 'userdelete'} content />
          <MenuItem title="Logout" active={active === 'b'} onClick={() => logoutNow()} logout />

          <UpdateAppData />
        </div>
      )}
    </div>
  );
};

const MenuItem = ({
  to,
  title,
  active,
  onClick,
  heading,
  logout,
  content,
  analytics,
  translation,
  superadminOnly,
}) => {
  const user = useSelector((state) => state?.auth?.user);
  const { role, adminCapabilities = [] } = user || {};

  const renderMenuItem = () => {
    // Superadmin-only items
    if (superadminOnly) {
      return adminCapabilities.includes('superadmin');
    }

    // Content capability required
    if (content) {
      return role === 'admin' && hasCapability(adminCapabilities, 'content');
    }

    // Analytics capability required
    if (analytics) {
      return role === 'admin' && hasCapability(adminCapabilities, 'analytics');
    }

    // Translation capability required
    if (translation) {
      return role === 'admin' && hasCapability(adminCapabilities, 'translation');
    }

    // Legacy role-based checks (photographer_editor, knowledge_editor, calendar_editor)
    if (
      (role === 'photographer_editor' && to === '/tools') ||
      (role === 'knowledge_editor' && to === '/knowledge') ||
      (role === 'calendar_editor' && to === '/home')
    ) {
      return true;
    }

    // Logout is always visible
    if (logout) {
      return true;
    }

    // Headings without capability requirements
    if (heading && !content && !analytics) {
      return true;
    }

    return false;
  };

  return renderMenuItem() ? (
    <li
      className={`relative z-10 flex flex-row h-7 mx-2 my-1px rounded ${
        active && 'border-2 border-white'
      }`}
    >
      {heading && <div className="text-base text-white ml-2 my-auto ">{title}</div>}
      {to && (
        <Link to={to} title={title} className="text-base text-white ml-2 my-auto">
          {title}
        </Link>
      )}
      {logout && (
        <div
          type="button"
          title={title}
          className="text-base text-white ml-2 my-auto focus:underline cursor:pointer"
          onClick={() => onClick()}
        >
          {title}
        </div>
      )}
    </li>
  ) : null;
};

export default MobileNav;
